import { generatePopup } from "../../utility/popup";
import * as actionTypes from "../ActionTypes";
import { apiGet, apiPost, apiPut } from "../axios";

export const AddSaleTransaction = (payload, dispatch) => {
  const token = localStorage.getItem("token");
  return async (dispatch) => {
    dispatch({
      type: actionTypes.ADD_SALE_INIT,
    });

    try {
      const response = await apiPost("addsale", payload, token);
      if (response.status === 200) {
        dispatch({
          type: actionTypes.ADD_SALE_SUCCESS,
          payload: response.data,
        });
        generatePopup("success", response?.data?.message);
        return response.data;
      } else {
        dispatch({
          type: actionTypes.ADD_SALE_FAIL,
          payload: response?.data?.message,
        });
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      if (error?.status === 404) {
        dispatch({
          type: actionTypes.ADD_SALE_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 403) {
        dispatch({
          type: actionTypes.ADD_SALE_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 400) {
        dispatch({
          type: actionTypes.ADD_SALE_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      }
      return error;
    }
  };
};

export const AddPurchaseTransaction = (payload, dispatch) => {
  const token = localStorage.getItem("token");
  return async (dispatch) => {
    dispatch({
      type: actionTypes.ADD_PURCHASE_INIT,
    });
    try {
      const response = await apiPost("addpurchase", payload, token);
      if (response.status === 200) {
        dispatch({
          type: actionTypes.ADD_PURCHASE_SUCCESS,
          payload: response.data,
        });
        generatePopup("success", response?.data?.message);
        return response.data;
      } else {
        dispatch({
          type: actionTypes.ADD_PURCHASE_FAIL,
          payload: response?.data?.message,
        });
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      if (error?.status === 404) {
        dispatch({
          type: actionTypes.ADD_PURCHASE_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 403) {
        dispatch({
          type: actionTypes.ADD_PURCHASE_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 400) {
        dispatch({
          type: actionTypes.ADD_PURCHASE_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 401) {
        dispatch({
          type: actionTypes.ADD_PURCHASE_FAIL,
          payload: error?.data?.message,
        });
        localStorage.clear();
        generatePopup("error", error?.data?.message);
      }
      return error;
    }
  };
};

export const AddExpenseTransaction = (payload, dispatch) => {
  const token = localStorage.getItem("token");
  return async (dispatch) => {
    dispatch({
      type: actionTypes.ADD_EXPENSE_INIT,
    });
    try {
      const response = await apiPost("addexpense", payload, token);
      if (response.status === 200) {
        dispatch({
          type: actionTypes.ADD_EXPENSE_SUCCESS,
          payload: response.data,
        });
        generatePopup("success", response?.data?.message);
        return response.data;
      } else {
        dispatch({
          type: actionTypes.ADD_EXPENSE_FAIL,
          payload: response?.data?.message,
        });
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      if (error?.status === 404) {
        dispatch({
          type: actionTypes.ADD_EXPENSE_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 403) {
        dispatch({
          type: actionTypes.ADD_EXPENSE_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 400) {
        dispatch({
          type: actionTypes.ADD_EXPENSE_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 401) {
        dispatch({
          type: actionTypes.ADD_EXPENSE_FAIL,
          payload: error?.data?.message,
        });
        localStorage.clear();
        generatePopup("error", error?.data?.message);
      }
      return error;
    }
  };
};

export const GetSale = (payload, dispatch) => {
  const token = localStorage.getItem("token");
  return async (dispatch) => {
    dispatch({
      type: actionTypes.GET_SALE_INIT,
    });

    try {
      // If payload.selectedId is an array, join the elements into a comma-separated string
      const selectedIdString = Array.isArray(payload?.selectedId)
        ? payload?.selectedId?.join(",")
        : payload?.selectedId;

      const response = await apiGet(
        `getsales?page=${payload?.page}&limit=${payload?.limit}&createdBy=${
          selectedIdString ? selectedIdString : ""
        }&startDate=${payload?.startDate ? payload?.startDate : ""}&endDate=${
          payload?.endDate ? payload?.endDate : ""
        }&status=${payload?.status ? payload?.status : undefined}&minAmount=${
          payload?.minAmount ? payload?.minAmount : 0
        }&maxAmount=${payload?.maxAmount ? payload?.maxAmount : 0}&storeName=${
          payload?.storeName ? payload?.storeName : ""
        }`,
        token
      );
      if (response.status === 200) {
        dispatch({
          type: actionTypes.GET_SALE_SUCCESS,
          payload: response.data,
        });
        // generatePopup("success", response?.data?.message);
        return response.data;
      } else {
        dispatch({
          type: actionTypes.GET_SALE_FAIL,
          payload: response?.data?.message,
        });
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      if (error?.status === 401) {
        dispatch({
          type: actionTypes.GET_SALE_FAIL,
          payload: error?.data?.message,
        });
        localStorage.clear();
        generatePopup("error", error?.data?.message);
      }
      return error;
    }
  };
};

export const UpdateSaleTransaction = (payload, dispatch) => {
  const token = localStorage.getItem("token");
  return async (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_SALE_INIT,
    });

    try {
      const response = await apiPut(
        `salesup/${payload?.id}`,
        payload?.data,
        token
      );
      if (response.status === 200) {
        dispatch({
          type: actionTypes.UPDATE_SALE_SUCCESS,
          payload: response.data,
        });
        generatePopup("success", response?.data?.message);
        return response.data;
      } else {
        dispatch({
          type: actionTypes.UPDATE_SALE_FAIL,
          payload: response?.data?.message,
        });
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      if (error?.status === 404) {
        dispatch({
          type: actionTypes.UPDATE_SALE_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 401) {
        dispatch({
          type: actionTypes.UPDATE_SALE_FAIL,
          payload: error?.data?.message,
        });
        localStorage.clear();
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 400) {
        dispatch({
          type: actionTypes.UPDATE_SALE_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      }
      return error;
    }
  };
};

export const GetPurchase = (payload, dispatch) => {
  const token = localStorage.getItem("token");
  return async (dispatch) => {
    dispatch({
      type: actionTypes.GET_PURCHASE_INIT,
    });

    try {
      const response = await apiGet(
        `getpurchases?page=${payload?.page}&limit=${payload?.limit}&storeName=${
          payload?.storeName ? payload?.storeName : ""
        }&type=${payload?.type}`,
        token
      );
      if (response.status === 200) {
        dispatch({
          type: actionTypes.GET_PURCHASE_SUCCESS,
          payload: response.data,
        });
        // generatePopup("success", response?.data?.message);
        return response.data;
      } else {
        dispatch({
          type: actionTypes.GET_PURCHASE_FAIL,
          payload: response?.data?.message,
        });
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      if (error?.status === 401) {
        dispatch({
          type: actionTypes.GET_PURCHASE_FAIL,
          payload: error?.data?.message,
        });
        localStorage.clear();
        generatePopup("error", error?.data?.message);
      }
      return error;
    }
  };
};

export const UpdatePurchase = (payload, dispatch) => {
  const token = localStorage.getItem("token");
  return async (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_PURCHASE_INIT,
    });

    try {
      const response = await apiPut(
        `purchasesup/${payload?.id}`,
        payload?.data,
        token
      );
      if (response.status === 200) {
        dispatch({
          type: actionTypes.UPDATE_PURCHASE_SUCCESS,
          payload: response.data,
        });
        generatePopup("success", response?.data?.message);
        return response.data;
      } else {
        dispatch({
          type: actionTypes.UPDATE_PURCHASE_FAIL,
          payload: response?.data?.message,
        });
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      if (error?.status === 404) {
        dispatch({
          type: actionTypes.UPDATE_PURCHASE_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 401) {
        dispatch({
          type: actionTypes.UPDATE_PURCHASE_FAIL,
          payload: error?.data?.message,
        });
        localStorage.clear();
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 400) {
        dispatch({
          type: actionTypes.UPDATE_PURCHASE_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      }
      return error;
    }
  };
};

export const GetExpense = (payload, dispatch) => {
  const token = localStorage.getItem("token");
  return async (dispatch) => {
    dispatch({
      type: actionTypes.GET_EXPENSE_INIT,
    });

    try {
      const response = await apiGet(
        `getexpenses?page=${payload?.page}&limit=${payload?.limit}&storeName=${
          payload?.storeName ? payload?.storeName : ""
        }`,
        token
      );
      if (response.status === 200) {
        dispatch({
          type: actionTypes.GET_EXPENSE_SUCCESS,
          payload: response.data,
        });
        // generatePopup("success", response?.data?.message);
        return response.data;
      } else {
        dispatch({
          type: actionTypes.GET_EXPENSE_FAIL,
          payload: response?.data?.message,
        });
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      if (error?.status === 401) {
        dispatch({
          type: actionTypes.GET_EXPENSE_FAIL,
          payload: error?.data?.message,
        });
        localStorage.clear();
        generatePopup("error", error?.data?.message);
      }
      return error;
    }
  };
};

export const UpdateExpenses = (payload, dispatch) => {
  const token = localStorage.getItem("token");
  return async (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_EXPENSES_INIT,
    });

    try {
      const response = await apiPut(
        `expensesup/${payload?.id}`,
        payload?.data,
        token
      );
      if (response.status === 200) {
        dispatch({
          type: actionTypes.UPDATE_EXPENSES_SUCCESS,
          payload: response.data,
        });
        generatePopup("success", response?.data?.message);
        return response.data;
      } else {
        dispatch({
          type: actionTypes.UPDATE_EXPENSES_FAIL,
          payload: response?.data?.message,
        });
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      if (error?.status === 404) {
        dispatch({
          type: actionTypes.UPDATE_EXPENSES_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 401) {
        dispatch({
          type: actionTypes.UPDATE_EXPENSES_FAIL,
          payload: error?.data?.message,
        });
        localStorage.clear();
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 400) {
        dispatch({
          type: actionTypes.UPDATE_EXPENSES_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      }
      return error;
    }
  };
};
